import React, { Component } from 'react';
import TopBarNav from '../Layout/sideBarNav/TopBarNav';
import ReportViewer from './ReportViewer';
import { actionCreators } from "../../store/Reports";
import { actionCreators as modalActions } from "../../store/Modal";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

class ReportList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedReportName: 'ReportCatalog'
        };
    }

    getReportName = reportNameFromNavMenu => {
        this.setState({ selectedReportName: reportNameFromNavMenu });
    }


    render() {
        ///const isFirstLoad = this.state.selectedReportName === 'ReportCatalog'? true : false;
        const { isLoading } = this.props;
        //var rptParams = Array[{ BOLNumber: "9" }];
        return (
            <div >
                {isLoading && <div className="spinner" />}
                <TopBarNav getUserSelection={this.getReportName} />
                <ReportViewer isModalWindow="false" reportName={this.state.selectedReportName} rptParameters={{ "UserName": this.props.user.sub }}/>
            </div>
        );
    }
}

ReportList.propTypes = {};
ReportList.defaultProps = {};
const
    mapStateToProps = state => ({
        user: state.userAuthentication.user,
        selectedReportName: state.selectedReportName

    });
const mapDispatchToProps = dispatch =>
    ({
        actions: bindActionCreators(actionCreators, dispatch),
        modalActions: bindActionCreators(modalActions, dispatch)
    });
export default connect(mapStateToProps, mapDispatchToProps)(ReportList);